import type { ChatFetchers } from '../../fetchers/chat/chat-fetchers';

const CANCEL_ATTEMPTS = 5;
const CANCEL_RETRY_DELAY_MS = 500;

// Closing the stream cancels the run, but the server only releases the thread's run lock once the
// run has wound down; until then the cancel is refused, so it is retried a few times.
export const cancelTurnWithRetry = async (
    cancelChatTurn: ChatFetchers['cancelChatTurn'],
    threadId: string,
): ReturnType<ChatFetchers['cancelChatTurn']> => {
    for (let attempt = 1; ; attempt += 1) {
        const result = await cancelChatTurn(threadId);
        if (result.isOk || attempt === CANCEL_ATTEMPTS) return result;
        await new Promise((resolve) => setTimeout(resolve, CANCEL_RETRY_DELAY_MS * attempt));
    }
};
